import {
    BETBOOK_TICKETS,
    COMMUNITY_ANALYSES,
    COMMUNITY_ANALYSIS_DETAIL,
    COMMUNITY_EDIT_ANALYSIS,
    COMMUNITY_EDIT_TICKET,
    COMMUNITY_NEW_ANALYSIS,
    COMMUNITY_NEW_TICKET,
    COMMUNITY_TICKET_DETAIL
} from '@/routing/routes';
import { BetbooPostTypeOptions, POST_ANALYSIS } from 'nike-ui/src/components/betbook/constants';
import { useReframe } from 'nike-re-framejs';

export function betbookEditRoute(postType: BetbooPostTypeOptions) {
    if (postType === POST_ANALYSIS) {
        return COMMUNITY_EDIT_ANALYSIS;
    }
    return COMMUNITY_EDIT_TICKET;
}

export function betbookNewRoute(postType: BetbooPostTypeOptions) {
    if (postType === POST_ANALYSIS) {
        return COMMUNITY_NEW_ANALYSIS;
    }
    return COMMUNITY_NEW_TICKET;
}

export function betbookDetailRoute(postType: BetbooPostTypeOptions) {
    if (postType === POST_ANALYSIS) {
        return COMMUNITY_ANALYSIS_DETAIL;
    }
    return COMMUNITY_TICKET_DETAIL;
}

export function betbookListRoute(postType: BetbooPostTypeOptions) {
    if (postType === POST_ANALYSIS) {
        return COMMUNITY_ANALYSES;
    }
    return BETBOOK_TICKETS;
}

export function useBetslipActive() {
    const derefSub = useReframe();
    const picksCount = derefSub(['betslip/picksCount']);
    return picksCount > 0;
}
